import ApplicationDetails from "./applicationDetails";
export default ApplicationDetails
